import { useOutletContext } from 'react-router';
import { THEMES } from '../../utils/cms-utils';
import { useEffect } from 'react';

export const useBackgroundColor = (color = THEMES.HVIT) => {
    const outletContext = useOutletContext();

    useEffect(() => {
        if (outletContext?.setBackgroundColor) {
            outletContext.setBackgroundColor(color);
        }
    }, [outletContext?.setBackgroundColor, color]);
};
